module.exports = __webpack_public_path__ + "img/43_40.c5a81d6c.png";